"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HotMessages = void 0;
const net = require("@ivanlog/net");
const models_1 = require("./models");
const models_2 = require("./models");
class HotMessages {
    constructor(_client, _errorsHandler) {
        this._client = _client;
        this._errorsHandler = _errorsHandler;
        if (!this._errorsHandler)
            this._errorsHandler = (e, args) => { throw e; };
    }
    /**
    * Sign to drivers and customers push messages.
    Return 504 code if time out and need reconnect.
    Return 205 code if something wrong and need reconnect.
    * @returns {Promise<ResultFail|Array<HotMessage>|net.NetError|number>}
    */
    signUnsafe(fromPushId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/customer/api/v1/HotMessages/Sign";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("fromPushId=" + encodeURIComponent(fromPushId));
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.POST, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_1.HotMessage(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Sign to drivers and customers push messages.
    Return 504 code if time out and need reconnect.
    Return 205 code if something wrong and need reconnect.
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<HotMessage>>}
    */
    sign(fromPushId, body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.signUnsafe(fromPushId, body);
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
}
exports.HotMessages = HotMessages;
//# sourceMappingURL=HotMessages.js.map